import { ConnectedAccountsListProps } from 'screens/Schedule/FrequencySection/EditContentAccountsModal/Types'
import { AccountImage } from 'screens/Schedule/EditChannelsModal/Account'
import Styles from './ConnectedAccountsList.module.scss'
import cx from 'classnames'

const VISIBLE_ACCOUNT_LIMIT = 3

export const ConnectedAccountsList = ({ accounts, className }: ConnectedAccountsListProps) => {
  const visibleAccounts = accounts.slice(0, VISIBLE_ACCOUNT_LIMIT)
  const remainingCount = accounts.length - visibleAccounts.length

  return (
    <ul className={cx(Styles.list, className)}>
      {visibleAccounts.map((account) => (
        <li key={account.id}>
          <AccountImage integration={account} size={24} />
        </li>
      ))}
      {remainingCount > 0 && (
        <li>
          <div className={Styles.counter}>+{remainingCount}</div>
        </li>
      )}
    </ul>
  )
}
